import { ProductLabelContainer } from "./components/productLabel.container";
import { PromotionPeriodContainer } from "./components/promotionPeriode.container";
import { DiscountBase } from "./discount.base";

export const Discount = Object.assign(DiscountBase, {
    PromotionPeriode: PromotionPeriodContainer,
    ProductLabel: ProductLabelContainer
});
